module.exports = __webpack_public_path__ + "static/media/S1N12-1.d504f1c5.svg";